import { render, staticRenderFns } from "./RiskAcceptance.vue?vue&type=template&id=39c8cbd0&scoped=true&"
import script from "./RiskAcceptance.vue?vue&type=script&lang=js&"
export * from "./RiskAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./RiskAcceptance.vue?vue&type=style&index=0&id=39c8cbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8cbd0",
  null
  
)

export default component.exports